module.exports = __webpack_public_path__ + "img/wangjiadong.a228bed7.jpg";